import _Promise from "@babel/runtime-corejs2/core-js/promise";
import { createAction } from 'redux-act';
import { logging } from 'gandi.redux-logger';
import { selectCurrentId, selectPersonalId } from './selectors';
import sharingResource from './resource';

var logger = function logger(dispatch) {
  return logging(dispatch, 'gandi.sharing/modules/actions');
};

export var setCurrentId = createAction('Set current organization id');
export var setPersonalId = createAction('Set personal organization id'); // XXX: may be use redux-organization?

export var fetchOrganizations = function fetchOrganizations(query) {
  var accumulate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function (dispatch) {
    var baseUrl = '/organization/organizations';
    var url = query ? "".concat(baseUrl, "?").concat(query) : baseUrl;
    return dispatch(sharingResource.fetch(url, {
      label: query ? 'filtered' : undefined,
      accumulate: accumulate
    }));
  };
};
export var fetchOrganizationsWithSubset = function fetchOrganizationsWithSubset(query) {
  var accumulate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function (dispatch, getState) {
    var personalId = selectPersonalId(getState());
    var baseUrl = personalId ? "/organization/users/".concat(personalId, "/projects") : '/organization/organizations'; // fallback if personalId is undefined

    var url = query ? "".concat(baseUrl, "?").concat(query) : baseUrl;

    if (!personalId) {
      dispatch(logger).warn("No personalId. Fallback to route ".concat(url));
    }

    return dispatch(sharingResource.fetch(url, {
      label: query ? 'filtered' : undefined,
      accumulate: accumulate
    }));
  };
};
export var fetchOneOrganization = function fetchOneOrganization(id) {
  return function (dispatch) {
    return dispatch(sharingResource.fetchOne("/organization/organizations/".concat(id), {
      label: id
    }));
  };
};
export var fetchPersonal = function fetchPersonal() {
  return function (dispatch, getState) {
    var personalId = selectPersonalId(getState());
    dispatch(logger).info("Fetching personal organization: ".concat(personalId));
    return dispatch(fetchOneOrganization(personalId));
  };
};
export var fetchCurrentSharing = function fetchCurrentSharing(sharingId_) {
  var hasSubsetOrgSupport = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function (dispatch, getState) {
    var sharingId = sharingId_ || selectCurrentId(getState());
    dispatch(logger).info("Fetching current organization: ".concat(sharingId));

    if (!hasSubsetOrgSupport) {
      return dispatch(fetchOneOrganization(sharingId)).then(function (response) {
        dispatch(setCurrentId(sharingId));
        return response;
      });
    }

    var personalId = selectPersonalId(getState());

    if (!personalId) {
      return _Promise.reject(new Error('Undefined personal id! ' + "Reducer didn't handle the setPersonalId action?"));
    }

    dispatch(logger).info("Fetching subset organization ".concat(sharingId, " for user ").concat(personalId));
    return dispatch(sharingResource.fetchOne("/organization/users/".concat(personalId, "/projects/").concat(sharingId), {
      label: sharingId
    })).then(function (response) {
      dispatch(setCurrentId(sharingId));

      if (response.data.subset) {
        return response;
      }

      return dispatch(fetchOneOrganization(sharingId));
    });
  };
};
export var fetchCurrentSharingAndSetPersonal = function fetchCurrentSharingAndSetPersonal(sharingId, req) {
  var hasSubsetOrgSupport = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return function (dispatch, getState) {
    // eslint-disable-next-line testing-library/no-debugging-utils
    dispatch(logger).debug({
      tokeninfo: req.tokeninfo
    }, 'Setting Personal org with tokeninfo data ...');

    if (!sharingId) {
      sharingId = selectCurrentId(getState()); // eslint-disable-line no-param-reassign
    }

    dispatch(setPersonalId(req.tokeninfo.user_id));

    if (sharingId === req.tokeninfo.user_id) {
      return dispatch(fetchCurrentSharing(sharingId, hasSubsetOrgSupport));
    }

    return dispatch(fetchPersonal()).then(function () {
      return dispatch(fetchCurrentSharing(sharingId, hasSubsetOrgSupport));
    });
  };
};